import { Button } from '@tempo-io/sui-button';
import { FolderMap } from '@tempo-io/sui-icons';
import { Popover, PopoverContent, PopoverTrigger } from '@tempo-io/sui-popover';
import { ScrollArea } from '@tempo-io/sui-scrollarea';
import { useTranslation } from 'react-i18next';
import { Colors } from '@/lib/utils/common/colors';
import type { VisualizationColorItem } from './types';
import { VisualizationColorSwatch } from './VisualizationColorSwatch';

interface VisualizationColorLegendPopoverProps {
  items: VisualizationColorItem[];
  title: string;
}

export function VisualizationColorLegendPopover({
  items,
  title,
}: VisualizationColorLegendPopoverProps) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          aria-label={t('roadmapping.layout.colorLegend.open')}
          className={`h-10 w-10 p-0 rounded-full ${Colors.black.bg} ${Colors.white.text}`}
        >
          <FolderMap size={16} />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        side="top"
        align="end"
        className="w-[158px] p-0 overflow-hidden rounded-[12px]"
      >
        <div className={`w-full ${Colors.white.bg} rounded-[12px]`}>
          <div className={`px-3 py-2 text-sm font-semibold ${Colors.black.text}`}>{title}</div>

          <ScrollArea className="h-64 overflow-hidden w-full" type="always">
            <div className="w-full pb-2">
              {items.map((item) => (
                <VisualizationColorSwatch key={item.id} color={item.color} label={item.label} />
              ))}
            </div>
          </ScrollArea>
        </div>
      </PopoverContent>
    </Popover>
  );
}
